import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { id: 'products', label: 'PRODUCTS' },
    { id: 'gallery', label: 'GALLERY' },
    { id: 'order', label: 'ORDER' },
    { id: 'payment', label: 'PAYMENT' },
    { id: 'contact', label: 'CONTACT' },
  ];

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-40 transition-all duration-300"
      style={{
        background: scrolled ? 'rgba(20,20,20,0.97)' : 'transparent',
        borderBottom: scrolled ? '1px solid #2a2a2a' : 'none',
        backdropFilter: scrolled ? 'blur(8px)' : 'none',
      }}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => scrollTo('home')}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/edited_fef8d5247c92ac9a1969d8377d67a28e_8129bb92.jpg"
            alt="Logo"
            className="w-9 h-9 object-contain"
          />
          <span
            className="text-white text-sm uppercase tracking-widest hidden sm:block"
            style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
          >
            ZYN ORDERS
          </span>
        </button>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-[#aaa] hover:text-white font-mono text-xs tracking-[0.25em] uppercase transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('order')}
            className="px-5 py-2 bg-[#CE1126] border border-[#C0C0C0] text-white font-black text-xs tracking-[0.2em] uppercase transition-all duration-200 hover:-translate-y-0.5 active:scale-95 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
          >
            DISPATCH ORDER
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          className="md:hidden border-t border-[#2a2a2a] py-4 px-4"
          style={{ background: 'rgba(20,20,20,0.98)' }}
        >
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="block w-full text-left py-3 text-[#aaa] hover:text-white font-mono text-xs tracking-[0.25em] uppercase transition-colors duration-200 cursor-pointer border-b border-[#1a1a1a]"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('order')}
            className="mt-4 w-full py-4 bg-[#CE1126] border border-[#C0C0C0] text-white font-black text-sm tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer"
            style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
          >
            DISPATCH ORDER
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
